import { HttpRequestWrapper } from "./HttpRequestWrapper";
import { MsGraphTokenService } from "./MsGraphTokenService";

export class GraphRequestWrapper {
    constructor(private httpRequestWrapper: HttpRequestWrapper, private msGraphTokenService: MsGraphTokenService) {}

    async get(
        url: string,
        dataType?: string,
        headers?: JQuery.PlainObject<string | null | undefined>,
        data?: any,
        options?: any
    ) {
        try {
            const accessToken = await this.msGraphTokenService.getGraphToken();
            const headersWithAuthorization = {
                ...headers,
                Authorization: `Bearer ${accessToken}`,
            };
            return await this.httpRequestWrapper.get(url, dataType, headersWithAuthorization, data, options);
        } catch (error) {
            if ((error as any).status && (error as any).status === 401) {
                const newToken = await this.msGraphTokenService.getNewGraphTokenFromAPI();
                const headersWithAuthorization = {
                    ...headers,
                    Authorization: `Bearer ${newToken}`,
                };
                return this.httpRequestWrapper.get(url, dataType, headersWithAuthorization, data, options);
            }
            throw error;
        }
    }

    async post(
        url: string,
        dataType?: string,
        headers?: JQuery.PlainObject<string | null | undefined>,
        data?: string,
        options?: any
    ) {
        try {
            const accessToken = await this.msGraphTokenService.getGraphToken();
            const headersWithAuthorization = {
                ...headers,
                Authorization: `Bearer ${accessToken}`,
            };
            return await this.httpRequestWrapper.post(url, dataType, headersWithAuthorization, data, options);
        } catch (error) {
            if ((error as any).status && (error as any).status === 401) {
                const newToken = await this.msGraphTokenService.getNewGraphTokenFromAPI();
                const headersWithAuthorization = {
                    ...headers,
                    Authorization: `Bearer ${newToken}`,
                };
                return this.httpRequestWrapper.post(url, dataType, headersWithAuthorization, data, options);
            }
            throw error;
        }
    }

    async patch(
        url: string,
        dataType?: string,
        headers?: JQuery.PlainObject<string | null | undefined>,
        data?: string,
        options?: any
    ) {
        const msGraph = this.msGraphTokenService;

        let accessToken: any;

        try {
            accessToken = await msGraph.getGraphToken();
            const headersAuth = { ...headers, Authorization: `Bearer ${accessToken}` };

            return this.httpRequestWrapper.patch(url, dataType, headersAuth, data, options);
        } catch (error) {
            if ((error as any).status && (error as any).status === 401) {
                const newAccessToken = await msGraph.getNewGraphTokenFromAPI(); // token expired
                const headersAuth = { ...headers, Authorization: `Bearer ${newAccessToken}` };
                return this.httpRequestWrapper.patch(url, dataType, headersAuth, data, options);
            }
            throw error;
        }
    }
    // Leaving this in place even though currently not called as it should be considered part of a functional library
    /*
    async delete(url: string, dataType?: string, headers?: JQuery.PlainObject<string | null | undefined>) {
        const msGraph = this.msGraphTokenService;

        let accessToken: any;
        let headersAuth: any;

        try {
            accessToken = await msGraph.getGraphToken();

            headersAuth = { ...headers, Authorization: `Bearer ${accessToken}` };

            return this.httpRequestWrapper.delete(url, dataType, headersAuth);
        } catch (error) {
            if ((error as any).status && (error as any).status === 401) {
                const newAccessToken = await msGraph.getNewGraphTokenFromAPI(); // token expired

                headersAuth = { ...headers, Authorization: `Bearer ${newAccessToken}` };
                return this.httpRequestWrapper.delete(url, dataType, headersAuth);
            }
            throw error;
        }
    } */
}
